import BaseApiClient from '../BaseApiClient';

interface DataListInterface {
  id: string;
  name: string;
  options: Array<{ id: string; label: string; is_other: boolean }>;
}

export class ApiConfidenceLevels extends BaseApiClient {
  async all(): Promise<DataListInterface | null> {
    return new Promise<DataListInterface | null>((resolve, reject) => {
      this.client
        .get('/data-lists?filter[group]=task')
        .then((res) => {
          if (res.data) {
            const confidenceLevels = res.data.data.find(
              (dataList: DataListInterface) => dataList.name === 'confidence'
            );
            resolve(confidenceLevels ?? null);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { confidenceLevelsQueryKeys } from './query-keys';
export { useConfidenceLevelsQuery } from './use-confidence-levels-queries';

